import React from 'react';

const AWS_Cloud_Quiz = () => {
  return (
    <div>
      <h1>AWS_Cloud_Quiz</h1>
      <p>This is the AWS_Cloud_Quiz component.</p>
    </div>
  );
};

export default AWS_Cloud_Quiz;
